module.exports = __webpack_public_path__ + "assets/img/zgzx.6002414e.jpg";